import React from "react";

import { faAlignLeft, faAngleDown, faAngleUp } from "@awesome.me/kit-4c83d50d0d/icons/classic/regular";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cx from "classnames";

import formatEventDescription from "~/calendar/utils/formatEventDescription";

import type { RowProps } from "./index";

import styles from "./ViewEvent.module.css";

export default function DescriptionRow({ eventData }: RowProps) {
	const descriptionRef = React.useRef<HTMLDivElement | null>(null);
	const [expandable, setExpandable] = React.useState(false);
	const [extended, setExtended] = React.useState(false);
	React.useEffect(() => {
		const height = descriptionRef.current?.scrollHeight;
		if (height && height > 110) {
			setExpandable(true);
			setExtended(false);
		} else {
			setExpandable(false);
		}
	}, [eventData?.description]);

	const onReadMoreClick = React.useCallback(() => {
		setExtended(true);
	}, []);

	const onReadLessClick = React.useCallback(() => {
		setExtended(false);
	}, []);

	if (!eventData?.description) {
		return null;
	}

	const formattedDescription = formatEventDescription(eventData.description);

	if (!(formattedDescription && /\S/.test(formattedDescription))) return null;

	return (
		<div className={styles.infoRow}>
			<div className={cx(styles.infoRow__icon, styles.centeredOnFirstLine)}>
				<FontAwesomeIcon fixedWidth icon={faAlignLeft} />
			</div>
			<div className={styles.infoRow__text}>
				<p
					className={cx(styles.descriptionWrapper, { [styles.extended]: extended })}
					ref={descriptionRef}
					dangerouslySetInnerHTML={{ __html: formattedDescription }}
				/>

				{expandable &&
					(extended ? (
						<div className={styles.showMoreLessButton} onClick={onReadLessClick}>
							Read less <FontAwesomeIcon icon={faAngleUp} />
						</div>
					) : (
						<div className={styles.showMoreLessButton} onClick={onReadMoreClick}>
							Read more <FontAwesomeIcon icon={faAngleDown} />
						</div>
					))}
			</div>
		</div>
	);
}
